export * from './marital-status.enum';
export * from './matrimonial-regime.enum';
export * from './create-owner.dto';
export * from './owner.dto';
export * from './get-update-owner-personal-data.dto';
export * from './get-update-owner-documents.dto';
export * from './get-update-owner-contact.dto';
export * from './owner-simplified.dto';
export * from './owner-status.enum';
export * from './owner-fill-in-status.dto';
